var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateLead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "#1B1D1E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 18.5h-2.5V16h-2v2.5H16v2h2.5V23h2v-2.5H23v-2Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10a4 4 0 1 0-6.126 3.387 6.002 6.002 0 0 0-3.655 7.223C9.675 21.467 11.727 22 14 22c.188 0 .373-.004.558-.01A6.266 6.266 0 0 1 14.5 21l.004-.193c.006-.268.012-.541.024-.818-.174.007-.35.011-.528.011l-.35-.005c-1.272-.036-2.461-.267-3.44-.643l-.201-.082L10 19l.005-.209a4.002 4.002 0 0 1 2.578-3.533l1.413-.537 1.422.538.19.078c.198.087.387.189.566.305.467-.422 1.069-.795 1.843-1.098a5.994 5.994 0 0 0-1.891-1.155A3.997 3.997 0 0 0 18 10Zm-4-2a2 2 0 0 0-1.203 3.597l.14.096 1.064.668 1.06-.665c.533-.335.878-.895.932-1.523L16 10a2 2 0 0 0-2-2Z",
    fill: "#1B1D1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateLead);
export default __webpack_public_path__ + "static/media/create-lead.ab6605b8.svg";
export { ForwardRef as ReactComponent };